import React from "react";
import {withNamespaces} from "react-i18next";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import DeviceGroupForm from "../_forms/DeviceGroupForm";
import {deviceGroupActions} from "../../../../actions/device-group.actions";
import {claimTypes} from "../../../../constants/claim.constants";
import DeviceGroupAssignToGroupForm from "../_forms/DeviceGroupAssignToGroupForm";


const DeviceGroupActionButtons = ({t, row, user, showModal, hideModal, editDeviceGroup, removeDeviceGroup}) => {
    const deviceGroupCrudPermission = user[`c_device-group.actions.crud`];
    const schedulePermission = user[`c_schedule`];

    const openModalRemoveGroup = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                removeDeviceGroup(row.id);
                hideModal();
            },
        }, 'confirm')
    };

    const openEditModal = (row) => {
        showModal({
            open: true,
            title: t('edit_device-group'),
            component: <DeviceGroupForm data={row} submit={onSubmitEditModal}/>,
        }, 'formModal')
    };

    const openModalAssignToGroup = (row) => {
        showModal({
            open: true,
            title: t('assign-to-group'),
            component: <DeviceGroupAssignToGroupForm data={row} submit={(data) => console.log(data)}/>
        }, 'formModal')
    };

    const onSubmitEditModal = (data) => {
        editDeviceGroup(data);
        hideModal();
    };

    return (
        <div>
            { schedulePermission === claimTypes.READ_WRITE ? (
                <Link to={`/panel/device-group/${row.id}/schedule`}>
                    <Button variant={"secondary"} className="mx-1">
                        <i className="fas fa-calendar"> </i>
                        &nbsp;
                        {t('schedule')}
                    </Button>
                </Link>
            ) : (<React.Fragment/>) }

            { deviceGroupCrudPermission === claimTypes.READ_WRITE ? (
            <Button variant={"outline-info"} className="mx-1" onClick={() => openModalAssignToGroup(row) } >
                <i className="fas fa-layer-group"> </i>
                &nbsp;
                {t('assign-to-group')}
            </Button>
            ) : (<React.Fragment/>) }

            { deviceGroupCrudPermission === claimTypes.READ_WRITE ? (
                <Button variant={"primary"} className="mx-1" onClick={() => openEditModal(row)}>
                    <i className="fas fa-edit"> </i>
                </Button>
            ) : (<React.Fragment/>) }

            { deviceGroupCrudPermission === claimTypes.READ_WRITE ? (
                <Button variant={"danger"} className="mx-1" onClick={() => openModalRemoveGroup(row)}>
                    <i className="fas fa-trash"> </i>
                </Button>
            ) : (<React.Fragment/>) }
        </div>
    )
};

const mapsStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editDeviceGroup: (deviceGroup) => {
        dispatch(deviceGroupActions.editDeviceGroup(deviceGroup))
    },
    removeDeviceGroup: (deviceGroupId) => {
        dispatch(deviceGroupActions.removeDeviceGroup(deviceGroupId))
    }
});

export default withNamespaces()(connect(mapsStateToProps, mapDispatchToProps)(DeviceGroupActionButtons));
